import React from 'react'
import ReactECharts from 'echarts-for-react'
import { Link, Element } from 'react-scroll'
import { Form, Input, Button, Radio, Row, Col, Collapse, Tag, Table } from 'antd'
import moment from 'moment'
import './PostCheckContent.scss'

const { Panel } = Collapse

/**
 * 檢測後畫面組件
 *
 * 顯示完整的檢測報告結果
 * 包含：雷達圖、分數、台灣地圖、轉換漏斗等
 */
const PostCheckContent = (props) => {
  // 從 props 解構所有需要的數據和函數
  const {
    // 數據
    radarOption,
    checkTime,
    snapshotData,
    taiwanMapOption,
    clientRatioOption,
    COUNTRY_ENGAGEMENT_DATA,
    countryMaxUsers,
    industryComparisonMetrics,

    // 圖片
    imgIconFixRed,
    imgIconArrow,

    // 函數
    handleFixQuation,
    CollapseOnChange,
    getCheckListItemStatus,
    openPopup,
    handleSubmitContactForm,

    // 其他狀態
    isSubmitContactForm,
    formLayout,
    validateMessages,
    t,
  } = props

  return (
    <div className="post-check-content">
      {/* 這裡是從 .new-content 搬過來的所有內容 */}
      {props.children}
    </div>
  )
}

export default PostCheckContent
